export enum RemoteEventTypes {
  UpdateNotificationsCount = 1,
}
